import React from "react";
import "./index.css";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { Routes } from "./routes";
import { Toaster } from "react-hot-toast";

import Navbar from "./components/Navbar";

function AppNavigation() {
    const { pathname } = useLocation();
    const isReviewLanding = pathname === "/" || pathname.replace(/\/$/, "") === "/quick-review";
    return isReviewLanding ? null : <Navbar />;
}

function App() {
    return (
        <Router>
            <div className="App">
                <AppNavigation />
                <Routes />
                <Toaster position="top-right" />
            </div>
        </Router>
    );
}

export default App;
